import { TwilioCall } from '@/types/app.types';
import { AppIncomingCall } from '../types';
import { Device } from '@twilio/voice-sdk';

export function normalizeTwilioIncomingCall(call: TwilioCall, device: Device | null): AppIncomingCall {
  const memberId = call?.customParameters.get('memberId');
  const supervisionId = call?.customParameters.get('supervisionId');

  return {
    provider: 'twilio',
    providerCall: call,
    callId: call.parameters.CallSid,
    from: call.parameters.From,
    to: call.parameters.To,
    type: isLiveCall(call) ? 'live' : isSwitchingCall(call) ? 'switching' : isMemberCall(call) ? 'member' : 'normal',
    supervisionId,
    memberId,
    onAnotherCall: !!device?.isBusy,
    isAlreadyRinging: (device?.calls?.length || 0) > 1,
  };
}

export function isLiveCall(incomingCall: TwilioCall) {
  const isCallWhisper = incomingCall.customParameters.get('superviseStrategy') === 'SuperviseConference';
  const hasSuperviseId = incomingCall.customParameters.get('supervisionId') !== 'undefined';
  return isCallWhisper && hasSuperviseId;
}

export function isSwitchingCall(incomingCall: TwilioCall) {
  const isSwitchedCall = incomingCall.customParameters.get('superviseStrategy') === 'switch';
  const hasSuperviseId = incomingCall.customParameters.get('supervisionId') !== 'undefined';
  return isSwitchedCall && hasSuperviseId;
}

export function isMemberCall(incomingCall: TwilioCall) {
  const isMemberCall = incomingCall.customParameters.get('superviseStrategy') === 'ConnectWithMember';
  return isMemberCall;
}
